import { Drawer } from "@kaltura/mediaspace-shared-ui";
import { useMediaDrawer } from "./MediaDrawerContext";
import { useEffect, useState } from "react";
import styled from "@emotion/styled";

/**
 * drawer component used in media page
 */
export const MediaDrawer = () => {
    const { isOpen, content, close } = useMediaDrawer();
    const [initialScrollPosition, setInitialScrollPosition] = useState(0);

    useEffect(() => {
        if (isOpen) {
            // Save the current scroll position when the drawer is opened
            setInitialScrollPosition(window.scrollY);
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        }
        else {
            document.body.style.overflow = "auto";
            window.scrollTo(0, initialScrollPosition);
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isOpen]);

    return (
        <DrawerContainer>
            <Drawer
                open={isOpen}
                onClose={close}
                maxWidth={808}
                PaperProps={{
                    sx: {
                        position: "absolute",
                        right: 0,
                    },
                }}
                ModalProps={{
                    disablePortal: true,
                    sx: {
                        position: "absolute",
                        right: 0,
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            position: "absolute",
                        },
                    },
                }}
                backgroundVariant={"translucent"}
                contentContainerVariant={"narrow"}
            >
                {content}
            </Drawer>
        </DrawerContainer>
    );
};

const DrawerContainer = styled("aside")({
    position: "relative",
    display: "contents",
});
